/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatMessageSenderRoleFromJSON, ChatMessageSenderRoleToJSON, } from './ChatMessageSenderRole.js';
/**
 * Check if a given object implements the ParticipantDto interface.
 */
export function instanceOfParticipantDto(value) {
    if (!('viewingUserRole' in value) || value['viewingUserRole'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined)
        return false;
    return true;
}
export function ParticipantDtoFromJSON(json) {
    return ParticipantDtoFromJSONTyped(json, false);
}
export function ParticipantDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'viewingUserRole': ChatMessageSenderRoleFromJSON(json['viewingUserRole']),
        'id': json['id'],
        'displayName': json['displayName'],
        'imageUrl': json['imageUrl'],
    };
}
export function ParticipantDtoToJSON(json) {
    return ParticipantDtoToJSONTyped(json, false);
}
export function ParticipantDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'viewingUserRole': ChatMessageSenderRoleToJSON(value['viewingUserRole']),
        'id': value['id'],
        'displayName': value['displayName'],
        'imageUrl': value['imageUrl'],
    };
}
